import City from "../models/City"; // Импортируем модель City

export default class CitiesService {
  static async fetchCities() {
    try {
      const response = await fetch("https://europe-west3-hyper-e122e.cloudfunctions.net/get_cities", {
        method: "GET",
        mode: "cors", // ✅ Обязательно включаем CORS
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
        }
      });

      console.log("HTTP-статус:", response.status); // Логируем статус ответа
      if (!response.ok) {
        throw new Error(`Ошибка HTTP: ${response.status} - ${response.statusText}`);
      }

      const jsonData = await response.json();
      console.log("Ответ с сервера:", jsonData); // Логируем JSON-ответ

      return jsonData.map(City.fromJson); // Конвертируем JSON в массив объектов City

    } catch (error) {
      console.log("ERROR HERE:", error);
      console.error("Ошибка при загрузке городов:", error);
      return [];
    }
  }
}